import { type PropsWithChildren, type ReactNode } from 'react';
import cn from 'clsx';

import styles from './Skeleton.module.css';

type SkeletonProps = PropsWithChildren<{
  loading: boolean;
  className?: string;
}>;

export const Skeleton = ({ loading, className, children }: SkeletonProps): ReactNode => {
  return loading ? <span className={cn(styles.baseClass, className)}>{children}</span> : <>{children}</>;
};
